'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import defaultIcon from 'bender-url!../../img/favicon.png';
import darkIcon from 'bender-url!../../img/favicon-dark.png';

var getFavicon = function getFavicon() {
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? darkIcon : defaultIcon;
};

var Favicon = function Favicon(_ref) {
  var rel = _ref.rel,
      type = _ref.type;
  return /*#__PURE__*/_jsx("link", {
    rel: rel,
    type: type,
    href: getFavicon()
  });
};

Favicon.propTypes = {
  type: PropTypes.string.isRequired,
  rel: PropTypes.string.isRequired
};
Favicon.defaultProps = {
  rel: 'shortcut icon',
  type: 'image/png'
};
export default Favicon;